<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
  <a-modal
    :title="props.detailData.name"
    :width="1000"
    :open="true"
    :confirmLoading="state.loading"
    @ok="onFormSubmit"
    @cancel="
      () => {
        emit('cancel')
      }
    "
    ><a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form>
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="代理商">
                <a-input v-model:value="queryParam.nickname" placeholder="代理商姓名或手机号"></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="9" :sm="24">
              <a-form-item label="状态">
                <a-select mode="multiple" v-model:value="queryParam.status" placeholder="请选择状态">
                  <a-select-option value="0">待使用</a-select-option>
                  <a-select-option value="1">已使用</a-select-option>
                  <a-select-option value="2">赠送</a-select-option>
                  <a-select-option value="3">过期</a-select-option>
                  <a-select-option value="4">作废</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="loadData">查询</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table :columns="columns" :loading="state.loading" :data-source="dataSource" :pagination="pagination" @change="onChange" rowKey="id">
        <template #bodyCell="{ column, record, index, text }">
          <template v-if="column.dataIndex === 'nickname'">
            <a>{{ record.nickname }}</a>
          </template>
          <template v-if="column.dataIndex === 'status'">
            <a-tag class="ant-tag-green" v-if="record.status == 0">待使用</a-tag>
            <a-tag class="ant-tag-gray" v-if="record.status == 1">已使用</a-tag>
            <a-tag class="ant-tag-gray" v-if="record.status == 3">已过期</a-tag>
            <a-tag class="ant-tag-gray" v-if="record.status == 4">已作废</a-tag>
          </template>
          <template v-if="column.dataIndex === 'operate'"> </template>
        </template>
      </a-table>
    </a-card>
  </a-modal>
</template>
<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, computed } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import type { PaginationProps } from 'ant-design-vue'
import dayjs from 'dayjs'
const format = 'YYYY-MM-DD HH:mm:ss'
const arrayMonent = [dayjs('00:00:00', 'HH:mm:ss'), dayjs('23:59:59', 'HH:mm:ss')]
const props = defineProps({
  detailData: {
    type: Object,
    default: () => {}
  }
})
const emit = defineEmits(['cancel'])
const columns = [
  {
    title: '代理商',
    dataIndex: 'nickname',
    width: 200
  },
  {
    title: '状态',
    dataIndex: 'status',
    width: 300
  },
  {
    title: '添加时间',
    dataIndex: 'created_at',
    width: 200
  },
  {
    title: '操作',
    dataIndex: 'operate',
    width: 200
  }
]
interface state {
  loading: boolean
}
const state = reactive<state>({
  loading: false
})
let queryParam = reactive<any>({
  full_name: ''
})
let dataSource = ref([])
const pagination = reactive<PaginationProps>({
  pageSize: 10,
  pageSizeOptions: ['10', '50', '100', '200', '1000', '2000'],
  current: 1,
  total: undefined,
  showSizeChanger: true,
  showQuickJumper: true,
  showTotal: (total) => `总数：${total}`
})
onMounted(() => {
  loadData()
})
const loadData = () => {
  state.loading = true
  // 获取到列表数据
  let requestParam = {
    url: '/admin/v1/couponuseList',
    method: 'post',
    data: Object.assign({ page: pagination.current, limit: pagination.pageSize, coupon_id: props.detailData.id }, queryParam)
  }
  baseService(requestParam).then((res) => {
    state.loading = false
    pagination.total = res.data.total_records
    dataSource.value = res.data.list.map((item) => ({ ...item, isDetail: false }))
  })
}
const onChange = (val) => {
  pagination.pageSize = val.pageSize
  pagination.current = val.current
  loadData()
}
const onFormSubmit = () => {
  emit('cancel')
}
</script>
